// «فقط تراکنش‌های این عضو» — how another screen opens a fund on its تراکنش‌ها
// tab, narrowed to one member.
//
// Carried in the navigation's `state`, not in the URL. The chip names the
// member, and a name in the address bar would ride along in every PostHog
// event's `$current_url` (see utilities/navigation/entryState). `state` lives
// in `history.state`, so it survives a reload and back/forward just as well.

/** Where the member filter was asked for — what the funnel groups by. */
export type TMemberFilterSource = 'member_record_link' | 'member_record_row'

export interface IFundMemberFilter {
    /** the member's Poolship id — what the server's `poolship` filter takes */
    poolship: number
    /**
     * What the chip calls them after «فقط تراکنش‌های»: their name, or «شما»
     * when the member is reading their own record.
     */
    label: string
}

export interface IFundTransactionsState {
    memberFilter: IFundMemberFilter
    source: TMemberFilterSource
}

/** The `navigate()` arguments that open a fund's list of one member's rows. */
export const fundTransactionsOf = (
    moneypoolId: string | number,
    filter: IFundMemberFilter,
    source: TMemberFilterSource
): [string, { state: IFundTransactionsState }] => [
    `/fund/${moneypoolId}`,
    { state: { memberFilter: filter, source } },
]

/**
 * The member filter a navigation brought, if it brought one. `state` is
 * whatever the screen that navigated here put there — other screens push
 * their own shapes onto /fund/:id — so it is checked, not trusted.
 */
export const readFundTransactionsState = (
    state: unknown
): IFundTransactionsState | null => {
    const candidate = (state as Partial<IFundTransactionsState> | null)
        ?.memberFilter
    if (
        !candidate ||
        typeof candidate.poolship !== 'number' ||
        !Number.isInteger(candidate.poolship) ||
        candidate.poolship <= 0
    ) {
        return null
    }
    const source = (state as Partial<IFundTransactionsState>).source
    return {
        memberFilter: {
            poolship: candidate.poolship,
            label:
                typeof candidate.label === 'string' && candidate.label.trim()
                    ? candidate.label.trim()
                    : 'این عضو',
        },
        source: source === 'member_record_row' ? source : 'member_record_link',
    }
}
